<template>
  <div class="item">
    <div class="dropdown">
      <select name="type" v-model="mutation">
        <option v-for="(option, index) in options" :value="option.value" :key="'reserve'+index" >{{option.label}}</option>
      </select>
      <div class="arrow">
        <FontAwesomeIcon icon="caret-down" />
      </div>
    </div>
    <a class="save" v-show="saveIconStatus" @click="save()"
      ><font-awesome-icon icon="save"
    /></a>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    "font-awesome-icon": FontAwesomeIcon,
    FontAwesomeIcon
  },
  props: {
    code: String,
    name: String,
    value: [String, Number],
    placeholder: String,
    dbTable: String,
    options: Array,
    autoSave: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  data() {
    return {
      originValue: "",
      type: "string",
      mutation: ""
    };
  },
  created() {
    this.originValue = this.value;
    this.mutation = this.value;
  },
  computed: {
    saveIconStatus() {
      console.log(this.mutation, this.originValue)
      return this.mutation !== this.originValue;
    }
  },
  methods: {
    save: function() {
      console.log("save");
      if (this.mutation !== this.originValue) {
        this.originValue = this.mutation;
        this.$emit("update-select", {
          code: this.code,
          name: this.name,
          dbTable: this.dbTable,
          mutation: this.mutation,
          origin: this.originValue,
          type: this.type
        });
      }
    },
    emitEditStatusEventToParent() {
      console.log("savedEventToParent in!!!")
      let changeStatusData = {
        code: this.code,
        warning: this.saveIconStatus
      };
      this.$emit('change-edit-status', changeStatusData)
    }
  },
  watch: {
    mutation: function(newVal, oldVal) {
      if(this.autoSave) this.save();
      return newVal;
    },
    saveIconStatus: function(newVal, oldVal) {
      console.log("saveIconStatus: ", newVal, oldVal)
      this.emitEditStatusEventToParent();
    }
  }
};
</script>
<style scoped src="../../../src/assets/css/shop-console.css"></style>
